// Componentes estilizados compartidos por los componentes de Contabilidad Siigo.
import { Button, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Btn = styled(Button)({
  borderRadius: "20px",
  backgroundColor: "#161e55",
  color: "#fff",
  textTransform: "none",
  "&:hover": { backgroundColor: "#A8C8AF" },
  "&:disabled": { backgroundColor: "#ccc", color: "#666" },
});

export const BtnDanger = styled(Button)({
  borderRadius: "20px",
  backgroundColor: "#b71c1c",
  color: "#fff",
  textTransform: "none",
  "&:hover": { backgroundColor: "#ef9a9a" },
  "&:disabled": { backgroundColor: "#ccc", color: "#666" },
});

export const Section = styled(Paper)({ padding: "16px", marginBottom: "16px" });
